import React, { useState } from 'react';
import PageDetails from '../PageDetails/PageDetails'
import TabFirst from '../TabFirst/TabFirst'


const tabsList = [
  {tabId: 'SOCIAL', displayText: 'Inspection'},
  {tabId: 'GAMES', displayText: 'Machine'},
  {tabId: 'NEWS', displayText: 'Workspace & Quality'},
  {tabId: 'FOOD', displayText: 'Inspection Tool'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Facebook',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/social-facebook.png',
    category: 'SOCIAL',
    categoryDetails:[
      {
        InspectionItem: "Filter Condition",
        Description:"Check for tears, holes, or damage to the hydraulic filter element.",
        ActionRequired: "Replace if damaged or excessively contaminated.",
      },
      {
        InspectionItem: "Contaminant Accumulation",
        Description:" Assess the level of contaminants trapped in the filter.",
        ActionRequired: "Clean or replace if heavily contaminated to maintain optimal filtration.",
      },
      {
        InspectionItem: "Housing Integrity",
        Description:"Inspect for cracks, leaks, or misalignment in the filter housing.",
        ActionRequired: "Repair or replace if damaged to ensure proper sealing.",
      },
      {
        InspectionItem: "Seal Integrity",
        Description:" Ensure the seal between the filter element and housing is intact.",
        ActionRequired: "Replace if damaged to prevent fluid leakage..",
      },
      {
        InspectionItem: "Flow Restriction:",
        Description:"Measure fluid flow through the filter.",
        ActionRequired: "Clean or replace if flow restriction is detected to prevent inefficiency.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify correct installation according to guidelines.",
        ActionRequired: "Reinstall if necessary to prevent leaks or improper function.",
      },
      {
        InspectionItem: "Compatibility Check",
        Description:"Confirm compatibility with the hydraulic system",
        ActionRequired: "Replace if compatibility issues are identified.",
      },
     

      {
        InspectionItem: "Maintenance History Review",
        Description:"Prioritize replacement based on maintenance records.",
        ActionRequired: "Schedule replacement or cleaning accordingly.",
      }
    ]
  },
  
  {
    appId: 2,
    appName: 'Subway Surfers',
    imageUrl:
      'https://www.kanwalenterprises.com/public/images/products/img-automotive-filter-manufacturing-machines.jpg',
    category: 'GAMES',
    
  },

  
  {
    appId: 4,
    appName: 'Inshorts',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/news-inshorts.png',
    category: 'NEWS',
    heading:'Hydraulic Filter System',
    content:"Crafted in Bengaluru, our Hydraulic Filter Systems are engineered to perfection for optimal performance in various industrial settings. With a focus on durability, corrosion resistance, and unparalleled efficiency, our systems are trusted by professionals worldwide. Each product undergoes rigorous design and development processes by our team of seasoned experts, ensuring adherence to our high-quality standards. From inception to delivery, we prioritize customer satisfaction, consistently meeting and exceeding market demands. As reputable manufacturers, suppliers, and exporters of Hydraulic Filter Systems,backed by competitive pricing and uncompromising quality. For reliable filtration solutions tailored to your industry needs, inquire with us today.",
    features : [
      'Smooth performance',
      'Long running life',
      'Durable construction',
      'Smooth operation',
      'Automatic function',
    ],

    specifications : [
      'The specifications are  not fixed for the product and  we provide what our clients ask for.',
     
    ],

  },
  
  {
    appId: 5,
    appName: 'Zomato',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/food-zomato.png',
    category: 'FOOD',
    imageUrl:""
  },
  
]

// Write your code here
const HydraulicFilterSysytemStore = () => {
  const [activeTabId, setActiveTabId] = useState(tabsList[0].tabId);
  const [searchInput, setSearchInput] = useState('');
  

  const getFilteredProjects = () => {
    const filterdata = appsList.filter(
      (eachdetails) => eachdetails.category === activeTabId
    );
    return filterdata;
  };

  const onchangestatus = (tabId) => {
    setActiveTabId(tabId);
  };

  const getinputdetails = (event) => {
    setSearchInput(event.target.value);
  };

  const fliterdataproject = getFilteredProjects();
  const searchresult = fliterdataproject.filter((eachfilterdata) =>
    eachfilterdata.appName.includes(searchInput)
  );

  return (
    <div className="appcontainer">
      <div className="cardcontainer">
        <div className="upcontainer">
          {/* <div className="search-input-container">
            <input
              type="search"
              className="search-input"
              placeholder="Search"
              onChange={getinputdetails}
            />
            <img
              src="https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png "
              alt="search icon"
              className="search_icon"
            />
          </div> */}
        </div>
        <ul className="tabitemcontainer">
          {tabsList.map((each) => (
            <TabFirst
              tabname={each}
              key={each.tabId}
              onchangestatus={onchangestatus}
              isActive={activeTabId === each.tabId}
            />
          ))}
        </ul>
        <ul className="appcontainer">
          {searchresult.map((each) => (
            <PageDetails Appitem={each} key={each.appId} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default HydraulicFilterSysytemStore;
